import Vue from 'vue';
export default {
  getAreaListAll(areaList) {
    return new Promise((resove, reject) => {
      const requestArr = areaList.map(code => {
        return this.getAreaList({code: code});
      });
      Vue.axios.all(requestArr)
        .then(Vue.axios.spread(function (...result) {
          resove(result);
        })).catch(error => {
          reject(error);
        });
    });
  },
  getAreaList(params) {
    return Vue.axios.get('/rx/oms/arongqi/api/v1.0/area/list', {params});
  },
  getReportEnums(params) {
    return Vue.axios.get('/rx/oms/arongqi/api/v1.0/report/enums', {params});
  },
  savePartnerRegister(body) {
    if (body.id) {
      return Vue.axios.post('/rx/oms/arongqi/api/v1.0/report/update', body);
    } else {
      return Vue.axios.post('/rx/oms/arongqi/api/v1.0/report/create', body);
    }
  },
  updatePartnerRegister(body) {
    return Vue.axios.post('/rx/oms/arongqi/api/v1.0/report/update', body);
  },
  getPartnerList(params) {
    // return Vue.axios.get('/rx/user/api/v1.0/service/partner/arongqi-list', {params});
    return Vue.axios.get('/rx/user//api/v1.0/service/product/list', {params});
  },
  getPartnerList1(params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/partner/arongqi-list', {params});
    // return Vue.axios.get('/rx/user//api/v1.0/service/product/list', {params});
  },
  // 商品详情
  getPartnerDetail1(params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/product/detail', {params});
  },
  // 服务组织详情
  getPartnerDetail(params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/partner/detail', {params});
  }
};
